import {
    TransactionColumn,
    TransactionView,
} from "../../../common/types/views/transactionViews";

export const DefaultTransactionView: TransactionView = {
    type: "transaction",
    options: {
        bulkActions: true,
        selection: true,
    },
    columns: [
        {
            id: TransactionColumn.DATE,
            options: {
                pin: "left",
            },
        },
        {
            id: TransactionColumn.DESCRIPTION,
        },
        {
            id: TransactionColumn.CATEGORY,
        },
        {
            id: TransactionColumn.ACCOUNT,
        },
        {
            id: TransactionColumn.AMOUNT,
            options: {
                pin: "right",
            },
        },
        {
            id: TransactionColumn.ENTITY,
            options: {
                header: "",
                pin: "right",
            },
        },
        {
            id: TransactionColumn.ACTIONS,
            options: {
                pin: "right",
            },
        },
    ],
    filters: {},
};
